import { QueryFeature } from '../../../config/queryClient';

enum QueryKey {
  ClientSettings = 'ClientSettings',
  CanUnlinkOrionConsumer = 'CanUnlinkOrionConsumer',
}

export const queryKeys = {
  clientSettings: (clientId: number) => [
    QueryFeature.ClientSettings,
    QueryKey.ClientSettings,
    clientId,
  ],

  canUnlinkOrionConsumer: (clientId: number) => [
    QueryFeature.ClientSettings,
    QueryKey.CanUnlinkOrionConsumer,
    clientId,
  ],
};
